import { useFormContext, Controller } from 'react-hook-form';

import { UserPreferredUnit } from '@core';
import { useTranslate } from '@i18n';
import { ToggleButtonWithValue, Heading4 } from '@ui';

import * as css from './UnitSection.css';

const units: UserPreferredUnit[] = ['metric', 'imperial', 'mixed'];

export const UnitSection = () => {
    const { control } = useFormContext();
    const t = useTranslate();
    return (
        <div className={css.unitSettings}>
            <Heading4>{t('user_settings.units_section')}</Heading4>
            <Controller
                control={control}
                name="userPreferredUnit"
                render={({ field }) => <UnitToggleButton userPreferredUnit={field.value} onSelect={field.onChange} />}
            />
        </div>
    );
};

type UnitToggleButtonProps = {
    userPreferredUnit: UserPreferredUnit;
    onSelect: (event: unknown) => void;
};

const UnitToggleButton = ({ userPreferredUnit, onSelect }: UnitToggleButtonProps) => {
    const t = useTranslate();
    return (
        <div className={css.unitSettingsSelection}>
            {units.map((unit) => (
                <ToggleButtonWithValue
                    key={unit}
                    onSelect={onSelect}
                    isActive={userPreferredUnit === unit}
                    variant="radio"
                    value={unit}
                    typographyVariant="h4"
                >
                    {t(`menu.user_settings_unit_${unit}`)}
                </ToggleButtonWithValue>
            ))}
        </div>
    );
};
